
import moment from 'moment';
import { Component, Vue } from 'vue-property-decorator';
import { getRecommendKeyword } from '@/api/mypage';
import { getHotSearchKeyword } from '@/api/searchLog';
import Calendar from '@/components/Calendar/index.vue';
import InfiniteLoading from 'vue-infinite-loading';
import { getAiStoreInfoList, getAiRecommendSearch, getAiRecommendKeywords } from '@/api/storeInfo';
import { getCurrentPosition } from '@/utils/mylocation';
import {
  getLat,
  getLng,
  setLat,
  setLng,
} from '@/utils/cookies';

@Component({
  components: {
    Calendar,
    InfiniteLoading,
  },
})

export default class extends Vue {
  mounted() {
    this.getHotSearchKeyword(); // 인기 검색어
    this.getRecommendKeyword(); // 추천 검색어
    this.getAiItemList(); // 여기 어떠요
    this.loadAiRecommendKeywords(); // AI 추천 키워드 로드
    this.slotVisibleDefault = true;
    this.slotVisble = false;
  }

  private slotVisibleDefault = true;

  private slotVisble = false;

  private apiUrl = process.env.VUE_APP_COMMON_API;

  private hotSearchKeyword = [];

  private handleSearch() {
    this.slotVisibleDefault = !this.slotVisibleDefault;
    this.slotVisble = !this.slotVisble;
    this.totalSearchQuery.searchValue = '';
  }

  private handleAiSearchOpen() {
    this.aiSearchVisible = true;
  }

  private async handleAiSearch() {
    const aiQuery: any = {
      companion: this.aiSearchQuery.companion,
      style: this.aiSearchQuery.style,
      minBudget: this.aiSearchQuery.minBudget,
      maxBudget: this.aiSearchQuery.maxBudget,
      lat: this.listQuery.lat,
      lng: this.listQuery.lng,
      page: 0,
      size: 6,
    };

    this.aiSearchLoading2 = true;
    try {
      const response = await getAiRecommendSearch(aiQuery);
      const aiSearchQuery = {
        companion: this.aiSearchQuery.companion,
        style: this.aiSearchQuery.style,
        minBudget: String(this.aiSearchQuery.minBudget),
        maxBudget: String(this.aiSearchQuery.maxBudget),
        lat: this.listQuery.lat,
        lng: this.listQuery.lng,
        startDate: this.listQuery.startDate || moment().format('YYYY-MM-DD'),
        endDate: this.listQuery.endDate || moment().add(1, 'days').format('YYYY-MM-DD'),
        adult: String(this.listQuery.adult || 1),
        child: String(this.listQuery.child || 0),
        isAiSearch: 'true',
      };
      this.$router.push({ name: 'TotalSearch', query: aiSearchQuery });
      this.aiSearchVisible = false;
    } catch (error) {
      this.$message.error('AI 추천 검색에 실패했습니다.');
    } finally {
      this.aiSearchLoading2 = false;
    }
  }

  private loading = true;

  private totalSearchQuery: any = {
    searchValue: '',
    industryIdx: null,
    startDate: moment().format('YYYY-MM-DD'),
    endDate: moment().add(1, 'days').format('YYYY-MM-DD'),
    region: '',
    lat: '37.566826',
    lng: '126.9786567',
    adult: 1,
    child: 0,
  }

  private handleClickKeyword(keyword: string) {
    this.totalSearchQuery.searchValue = keyword;
    this.$router.push({ name: 'TotalSearch', query: { ...this.totalSearchQuery } });
  }

  private handleTotalSearch(keyword: string) {
    this.totalSearchQuery.startDate = this.listQuery.startDate;
    this.totalSearchQuery.endDate = this.listQuery.endDate;
    this.$router.push({ name: 'TotalSearch', query: { ...this.totalSearchQuery } });
  }

  private filterDefault: any = {
    date: '',
    personnel: '성인2명 / 아동1명',
    personnelAdult: 2,
    personnelChild: 1,
    village: '',
  }

  private personnellist: any = {
    adult: 1,
    child: 0,
  }

  private recommendKeyword: any = [];

  private recommendlistQuery: any = {
    searchValue: '',
    page: 0,
    size: 12,
  }

  private HotListQuery: any = {
    searchValue: '',
    page: 0,
    size: 10,
  }

  private recommendLoading = false;

  private hotLoading = false;

  // 여기 어때요 로딩
  private aiSearchLoading = false;

  // AI 추천 검색 로딩 2
  private aiSearchLoading2 = false;

  // AI 추천 검색
  private aiSearchVisible = false;

  private aiSearchQuery: any = {
    companion: '',
    minBudget: 0,
    maxBudget: 200000,
    style: '',
  }

  // API에서 불러온 키워드 데이터
  private companionOptions: any[] = [];

  private styleOptions: any[] = [];

  // 키워드 데이터 로드
  private async loadAiRecommendKeywords() {
    try {
      const response = await getAiRecommendKeywords();
      const data = response.data;

      // companion과 style 옵션 설정
      this.companionOptions = data.companion || [];
      this.styleOptions = data.style || [];

      // 기본값 설정
      if (this.companionOptions.length > 0) {
        this.aiSearchQuery.companion = this.companionOptions[0].displayName;
      }
      if (this.styleOptions.length > 0) {
        this.aiSearchQuery.style = this.styleOptions[0].displayName;
      }
    } catch (error) {
      console.error('AI 추천 키워드 로드 실패:', error);
      this.$message.error('키워드 데이터를 불러오는데 실패했습니다.');
    }
  }

  // 인기 검색어
  private getHotSearchKeyword() {
    this.hotLoading = true;
    getHotSearchKeyword(this.HotListQuery).then((res) => {
      this.hotSearchKeyword = res.data;
      this.hotLoading = false;
    }).catch(() => {
      this.$message.error('인기 검색어를 불러오는데 실패하였습니다.');
    });
  }

  // 추천 검색어
  private getRecommendKeyword() {
    this.recommendLoading = true;
    getRecommendKeyword(this.recommendlistQuery).then((res) => {
      let tmpArray = [];
      const uniqueKeywords: any = new Set();
      tmpArray = res.data;
      // 중복제거
      tmpArray.forEach((item: any) => {
        if (!uniqueKeywords.has(item.keyword)) {
          uniqueKeywords.add(item.keyword);
          this.recommendKeyword.push(item);
        }
      });
      // this.recommendKeyword = tmpArray;
      this.recommendLoading = false;
    }).catch(() => {
      this.$message.error('추천 검색어를 불러오는데 실패하였습니다.');
    });
  }

  // 여기 어때요
  private aiItem = {
    stayList: [],
    restaurantList: [],
    placeList: [],
    leisureList: [],
    excitingList: [],
    productList: [],
  }

  private listQuery: any = {
    searchValue: '',
    industryIdx: null,
    startDate: moment().format('YYYY-MM-DD'),
    endDate: moment().add(1, 'days').format('YYYY-MM-DD'),
    region: '',
    lat: '37.566826',
    lng: '126.9786567',
    adult: 1,
    child: 0,
  }

  private async getAiItemList() {
    try {
      const position = await getCurrentPosition();
      this.listQuery.lat = position.lat;
      this.listQuery.lng = position.lng;
      this.totalSearchQuery.lat = position.lat;
      this.totalSearchQuery.lng = position.lng;
    } catch (error) {
      // 위치 정보를 가져오지 못하면 기본값 사용
      console.warn('위치 정보를 가져오지 못했습니다. 기본 위치로 설정합니다.');
    }

    // 위치 정보 가져오기 성공 여부와 관계없이 API 호출
    this.aiSearchLoading = true;
    try {
      const res = await getAiStoreInfoList({
        page: 0,
        size: 4,
        lat: this.listQuery.lat,
        lng: this.listQuery.lng,
        randomRange: 10,
        stayCnt: 1,
        restaurantCnt: 1,
        placeCnt: 1,
        leisureCnt: 1,
      });

      this.aiItem = {
        ...this.aiItem,
        ...res.data,
      };
    } catch (error) {
      this.$message.error('정보를 불러오는 데 실패했습니다.');
    } finally {
      this.aiSearchLoading = false;
    }
  }

  private handleItemClick(idx: any, type: any) {
    if (type === 1) { // 숙박
      this.$router.push({ name: 'StayDetail', params: { stayIdx: idx } });
    } else if (type === 2) { // 체험
      this.$router.push({ name: 'LeisureView', params: { idx } });
    } else if (type === 3) { // 레저
      this.$router.push({ name: 'LeisureView', params: { idx } });
    } else if (type === 4) { // 외식
      this.$router.push({ name: 'RestaurantView', params: { idx } });
    } else if (type === 5) { // 일반상품
      this.$router.push({ name: 'GoodsView', params: { uid: idx } });
    } else if (type === 6) { // 관광
      this.$router.push({ name: 'PlaceView', params: { idx } });
    }
  }

  // 캘린더
  private calendarLoading = false;

  private calendarData = []; // 달력 일별 데이터

  private selectedDay: string | null = '';

  private selectedMonth = moment().format('YYYY-MM');

  private handleChangeMonth(yearMonth: any) {
    this.selectedMonth = moment(yearMonth).format('YYYY-MM');
    this.calendarData = [];
  }

  private handleChoiceDate(startDate: string, endDate: string) {
    this.selectedDay = startDate;
    this.listQuery.startDate = startDate;
    this.listQuery.endDate = endDate;
  }

  private handleResetFormQuery() {
    this.totalSearchQuery = {
      searchValue: '',
      industryIdx: null,
      startDate: moment().format('YYYY-MM-DD'),
      endDate: moment().add(1, 'days').format('YYYY-MM-DD'),
      adult: 1,
      child: 0,
      page: 0,
      size: 4,
      region: '',
      lat: this.listQuery.lat,
      lng: this.listQuery.lng,
    };
    const calendarRef: any = this.$refs.calendar;
    if (calendarRef) calendarRef.removeActiveClass();
  }
}
